import PortalIdParser from 'PortalIdParser';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
// @ts-expect-error untyped import
import { useFavoriteReports } from '../../data/hooks/useFavoriteReports';
import { FAVORITE_ASSET_LIMIT_REACHED, INSUFFICIENT_ASSET_PERMISSION_LEVEL } from '../problems';
import { DATA_FETCHING_ERROR_PROBLEM_AND_MESSAGE
// @ts-expect-error untyped import
} from '../shared/dataProblemsAndMessages';
import { FAVORITE_ASSET_LIMIT } from './constants';
// @ts-expect-error untyped import
import { hasSufficientReportViewPermission } from '../../lib/report-logic';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { Link } from 'foundations-components/transitional/components/Link';
import { jsx as _jsx } from "react/jsx-runtime";
const useAddFavoriteReportProblem = ({
  report
}) => {
  const {
    data: favoriteReports,
    error
  } = useFavoriteReports();
  if (error) {
    return DATA_FETCHING_ERROR_PROBLEM_AND_MESSAGE;
  }
  if (!hasSufficientReportViewPermission(report)) {
    return {
      problem: INSUFFICIENT_ASSET_PERMISSION_LEVEL,
      disabledMessage: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "reporting-action-components.actions.favoriteAssets.report.add.disabled.permissionDenied"
      })
    };
  }
  if (favoriteReports.size >= FAVORITE_ASSET_LIMIT && !report.get('favorite')) {
    return {
      problem: FAVORITE_ASSET_LIMIT_REACHED,
      disabledMessage: /*#__PURE__*/_jsx(FormattedJSXMessage, {
        message: "reporting-action-components.actions.favoriteAssets.report.add.disabled.limitReached_jsx",
        elements: {
          UILink: Link
        },
        options: {
          href: `/reports-list/${PortalIdParser.get()}?filterFavorites=true`,
          limit: FAVORITE_ASSET_LIMIT
        }
      })
    };
  }
  return {
    problem: null,
    disabledMessage: null
  };
};
export default useAddFavoriteReportProblem;